import { StatusBar } from 'expo-status-bar';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Text,
    View,
    StyleSheet,
    KeyboardAvoidingView,
    Platform,
    ImageBackground,
    Keyboard,
    TextInput
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import Queries from '../../api/queries';
import RootStore from '../../Store';
import Colors from '../../Theme/Colors';
import typo from '../../Theme/Typo';
import Input from '../Input/Input';
import Button from '../Button/index';
import { Feather } from '@expo/vector-icons';

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const { userInfo } = RootStore.getInstance()

const Login = () => {
    const { t, i18n } = useTranslation()
    const [email, setEmail] = useState<String>("")
    const [password, setPassword] = useState<String>("")
    const [isError, setError] = useState<Boolean>(false)
    const [isSecure, setSecure] = useState<boolean>(true)
    const [modalConfig, setModalConfig] = useState({
        isVisible: false,
        text: "",
    })
    const queries = new Queries()

    const onSubmit = async () => {
        if (email === "" || password === "") {
            setError(true)
        } else if (password.length < 8) {
            setError(true);
        } else {
            setError(false)
            userInfo.loginByEmail(email.trim(), password);
        }
    }

    return (
        <SafeAreaView style={typo.mainBackground}>
            <View style={style.container}>
                <StatusBar style="dark" backgroundColor={Colors.oiqia} />
                <KeyboardAvoidingView
                    style={{ flex: 1 }}
                    behavior={"padding"}
                    enabled={Platform.OS === "ios" ? true : false}
                    keyboardVerticalOffset={Platform.OS === "ios" ? 40 : 0}
                >

                    <ImageBackground source={BG_PATH} style={typo.background}>
                        <View style={style.center}>
                            <View style={[typo.resCard]}>

                                <Text style={style.titleWelcome}>{t("WELCOME")}</Text>
                                <Input
                                    type="INPUT"
                                    placeHolder={t("EMAIL")}
                                    style={{ marginTop: 10 }}
                                    onChangeText={(e: String) => setEmail(e)}

                                />
                                <View style={style.buttonPassword}>
                                    <View style={style.wrapper}>
                                        <TextInput
                                            secureTextEntry={isSecure}
                                            accessibilityLabel={t("PASSWORD")}
                                            style={style.text}
                                            placeholder={t("PASSWORD")}
                                            autoCapitalize="none"
                                            selectTextOnFocus={false}
                                            onChangeText={(e: String) => setPassword(e)}
                                        />
                                    </View>
                                    {!isSecure ?
                                        <Feather name="eye-off" size={27} color={Colors.oiqia} style={{ alignSelf: 'center' }} onPress={() => setSecure(true)} />
                                        :
                                        <Feather name="eye" size={27} color={Colors.oiqia} style={{ alignSelf: 'center' }} onPress={() => setSecure(false)} />
                                    }
                                </View>
                                {isError &&
                                    <View>
                                        <Text style={[typo.body, { color: Colors.red }]}>{t("ERROR_LOGIN")}</Text>
                                    </View>
                                }
                                <View>
                                    <Button
                                        style={{ backgroundColor: isError ? Colors.grey : Colors.oiqia, borderRadius: 10, marginTop: 10 }}
                                        text={t("LOGIN")}
                                        onPress={() => {
                                            onSubmit()
                                            Keyboard.dismiss()
                                        }}
                                    />
                                </View>
                            </View>
                        </View>

                    </ImageBackground>
                </KeyboardAvoidingView>
            </View>
        </SafeAreaView>
    )
}

const style = StyleSheet.create({
    center: {
        flex: 1,
        justifyContent: "center",
    },
    titleWelcome: {
        fontSize: 18,
        color: "black",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "RobotoMedium"
    },
    container: {
        flex: 1,
        backgroundColor: "#fff",
    },
    buttonPassword: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
    },
    text: {
        height: "100%",
        textAlign: "left",
        paddingLeft: 10,
        fontSize: 17,
    },
    wrapper: {
        marginTop: 10,
        borderColor: "#ccc",
        borderWidth: 1,
        width: "85%",
        height: 50,
        borderRadius: 10,
        justifyContent: "center",
    },
})

export default observer(Login);